import { Address } from '../../entity/location/address';
import { State } from '../../entity/location/state';

export class StateTransformer {
    transform(stateInfo: any) : State {
        return new State(
            stateInfo.code,
            stateInfo.description
        )
    }

    deTransform(state: State) : any {
        return {
            code: state.code,
            description: state.name
        }
    }
}

export class AddressTransformer {
    transform(addressInfo: any) : Address {    
        let stateInfo = addressInfo.state
        return new Address(
            addressInfo.addressLine1,
            addressInfo.addressLine2,
            addressInfo.addressLine3,
            addressInfo.landmark,
            addressInfo.city,
            stateInfo ? new State(stateInfo.code, stateInfo.description) : new State(""),
            addressInfo.pincode
        )        
    }

    deTransform(address: Address) : any {
        return {
            addressLine1: address.line1,
            addressLine2: address.line2,
            addressLine3: address.line3,
            landmark: address.landmark,
            city: address.city,
            state: new StateTransformer().deTransform(address.state),
            pincode: address.zipcode
        }
    }
}